import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../shared/FormBuilder'

function General () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-4 nh-sub-head'>Demeanor</div>
      </div>
      <div className='row'>
        <div className='col-xs-3'>
          <CheckboxInput {...PEQuestionnaire.generalAlert} />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalPleasant}
          />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalTalkative}
          />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalNAD}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-4 nh-sub-head'>Oriented to:</div>
      </div>
      <div className='row'>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalPerson}
          />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalPlace}
          />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalTime}
          />
        </div>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalSituation}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.generalOther}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.generalOtherText} />
        </div>
      </div>
    </div>
  )
}

export default General
